import type { ChartOverlay } from "components/charts/modern/overlay/types";
import compareAsc from "date-fns/compareAsc";
import isAfter from "date-fns/isAfter";
import type { FlagsShapeValue, SeriesFlagsOptions } from "highcharts";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import type { IntlShape } from "react-intl";
import colors from "tailwindcss/colors";

export default function earningsFlagsSeries(
  intl: IntlShape,
  forSeriesId: string,
  overlay: ChartOverlay,
  notBefore?: Date,
): SeriesFlagsOptions {
  return {
    type: "flags",
    showInNavigator: false,
    data: overlay.data
      .filter((flag) => {
        return notBefore ? isAfter(flag.x, notBefore) : true;
      })
      .map((flag) => {
        if (flag.value === undefined) {
          return null;
        }
        return {
          x: new Date(flag.x).getTime(),
          title:
            flag.value < 0
              ? intl.formatMessage({
                  defaultMessage: "P",
                  description: "Abreviação de Prejuízo (Loss) no gráfico de cotação",
                  id: "/ywfi1",
                })
              : intl.formatMessage({
                  defaultMessage: "L",
                  description: "Abreviação de Lucro (Profit) no gráfico de cotação",
                  id: "lUFUzj",
                }),
          custom: flag,
          lineWidth: 1.5,
          fillColor: flag.value < 0 ? colors.pink[50] : colors.emerald[50],
          color: flag.value < 0 ? colors.pink[600] : colors.emerald[600],
          style: {
            color: flag.value < 0 ? colors.pink[600] : colors.emerald[600],
          },
        };
      })
      .filter(notUndefinedOrNull)
      .sort((a, b) => {
        return compareAsc(a.x, b.x);
      }),
    style: {
      fontFamily: "novel-mono-pro-condensed",
      fontSize: "12px",
    },
    shape: "circle" as FlagsShapeValue,
    zIndex: 1,
    width: 16,
    height: 16,
    onSeries: forSeriesId,
    enableMouseTracking: false,
    accessibility: {
      exposeAsGroupOnly: true,
      description: "Flags indicating yearly/quarterly earnings",
    },
  };
}
